import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  translation_en: {
    GLOBAL: {
      cancel_button: 'Cancel',
      save_button: 'Save',
      GRID_NO_DATA: 'No data available',
      GRID_NO_RESULT_DATA: 'No results found',
      action_edit: 'Edit',
      action_view: 'View',
      action_delete: 'Delete',
      action_restore: 'Restore',
      action_rating: 'Rating',
      SEARCH_RESULT_OF_SEARCH: 'Result',
      SEARCH_SEARCH_BUTTON: 'Search',
      SEARCH_CLEAR_BUTTON: 'Clear',
      Save: 'Save',
      close: 'Close',
      SEARCH_RESULT_OF_selected: 'Selected',
      alertPopup: 'Update User Info',
      updateUserInfo: 'Update',
      endSessionMessage: 'Your session has ended. Redirecting in',
      endSessionMessageUnits: 'seconds',
      sessionEnding: 'Session Ending',
      sorry: 'Sorry!',
      sorryMessage: 'We couldn\'t redirect you to the login page. Please try logging in again from the main system.',
      pageNotFound: 'Page Not Found',
      pageNotFoundMessage: 'The page you\'re looking for doesn\'t exist or has been moved.',
      returnHome: 'Return to Main System',
      goHome: 'Go Home',
      goBack: 'Go Back',
      needHelp: 'Need help? Contact support.',
      online: 'Online',
      clear: 'Clear',
      language: 'Language',
      arabic: 'Arabic',
      english: 'English'
    },
    LOGIN: {
      login_title: 'Login'
    },
    SIDEMENU: {
      dashboard: 'Dashboard',
      Requests: 'Requests',
      profiel: 'Profile',
      logout: 'Logout',
      units: 'Units',
      welcome: 'Welcome',
      systemTitle: 'Resource Management System',
      dynamicFields: 'Dynamic Fields',
      geoExtractor: 'Preview Points',
      submissions: 'Submissions'
    },
    WELCOME: {
      goodMorning: 'Good Morning',
      goodAfternoon: 'Good Afternoon',
      goodEvening: 'Good Evening',
      totalVehicles: 'Total Vehicles',
      activeNow: 'Active now',
      allUnits: 'All units',
      activeUnits: 'Active Units',
      currentlyActive: 'Currently active',
      activity: 'Activity',
      lastHour: 'Last hour',
      uptime: 'Uptime',
      systemStatus: 'System status',
      security: 'Security',
      secure: 'Secure',
      allSystemsGo: 'All systems go',
      quickActions: 'Quick Actions',
      viewDashboard: 'View Dashboard',
      dashboardDesc: 'Monitor all your vehicles in real-time',
      manageFleet: 'Manage Fleet',
      fleetDesc: 'Add, edit, or remove vehicles',
      geoExtractor: 'Preview Points',
      geoExtractorDesc: 'Extract and browse geofence data from your resources',
      dynamicFields: 'Dynamic Fields',
      dynamicFieldsDesc: 'Configure custom fields for your mobile app forms',
      sessionActive: 'Session Active',
      activeStatus: 'Active',
      blockedStatus: 'Blocked',
      daysLeft: 'Days Left',
      remaining: 'Days remaining',
      accountStatus: 'Account Status',
      accountName: 'Account Name',
      accountStatistics: 'Account Statistics',
      accountID: 'Account ID'
    },
    LANDING: {
      initializingSession: 'Initializing Session',
      connectingToWialon: 'Connecting to Wialon...',
      verifyingSession: 'Verifying Session...',
      loadingData: 'Loading Data...',
      missingSession: 'Missing session parameters',
      ready: 'Ready!',
      connect: 'Connect',
      verify: 'Verify',
      load: 'Load',
      authenticationFailed: 'Authentication Failed',
      pleaseTryLoggingInAgain: 'Please try logging in again from the main system.',
      redirectingToLogin: 'Redirecting to login...'
    },
    DYNAMIC_FIELDS: {
      title: 'Dynamic Fields',
      subtitle: 'Configure custom fields for your mobile app forms',
      addField: 'Add Field',
      editField: 'Edit Field',
      addNewField: 'Add New Field',
      noFieldsTitle: 'No Custom Fields Yet',
      noFieldsDesc: 'Create custom fields to collect additional data from your mobile app users',
      createFirstField: 'Create Your First Field',
      orderCol: '#',
      labelCol: 'Field name',
      typeCol: 'Type',
      requiredCol: 'Required',
      actionsCol: 'Actions',
      fieldLabel: 'Field Label',
      labelHelp: 'Display name shown to users',
      fieldName: 'Field Name',
      nameHelp: 'Internal identifier (no spaces)',
      fieldType: 'Field Type',
      options: 'Options (one per line)',
      required: 'Required Field',
      displayOrder: 'Display Order',
      orderHelp: 'Lower numbers appear first',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      yes: 'Yes',
      no: 'No',
      fetchError: 'Failed to load fields',
      validationError: 'Field name and label are required',
      updateSuccess: 'Field updated successfully',
      createSuccess: 'Field created successfully',
      saveError: 'Failed to save field',
      deleteSuccess: 'Field deleted successfully',
      deleteError: 'Failed to delete field',
      deleteConfirmTitle: 'Delete Field?',
      deleteConfirmMessage: 'Are you sure you want to delete this field? This action cannot be undone.',
      restoreSuccess: 'Field restored successfully',
      restoreError: 'Failed to restore field',
      restoreConfirmTitle: 'Restore Field?',
      restoreConfirmMessage: 'Are you sure you want to restore this field? It will become active again in the mobile app.',
      pointTitlePreview: 'Point Title Preview',
      searchPlaceholder: 'Search field name or label...',
      filterType: 'Field Type',
      allTypes: 'All Types',
      filterMandatory: 'Mandatory Status',
      allStatus: 'All',
      statusRequired: 'Required',
      statusOptional: 'Optional'
    },
    GEO_EXTRACTOR: {
      title: 'Preview Points',
      subtitle: 'Extract and browse geofence data from your resources',
      selectResource: 'Select Resource',
      search: 'Search...',
      refresh: 'Refresh',
      export: 'Export Excel',
      print: 'Print',
      viewTable: 'Table View',
      viewMap: 'Map',
      fullscreen: 'Fullscreen',
      exitFullscreen: 'Exit Fullscreen',
      openInGoogleMaps: 'Show in Google Maps',
      totalPoints: 'Total Points',
      matchingResults: 'Matching',
      extraFields: 'Extra Fields',
      loadingResources: 'Loading resources...',
      loadingZones: 'Processing geofences...',
      loadError: 'Failed to load resources',
      processError: 'Failed to process geofence data',
      noData: 'No WenkTag geofences found',
      noDataDesc: 'This resource has no WenkTag-formatted geofences. Try selecting another resource.',
      hideEmpty: 'Hide Empty Resources',
      searchSalesman: 'Search Salesman...',
      selectColumns: 'Select Columns...',
      searchDynamicFields: 'Search in columns...',
      advancedSearch: 'Advanced Search',
      resetFilters: 'Reset Filters'
    },
    SUBMISSIONS: {
      title: 'Field Submissions',
      subtitle: 'View and manage data submitted from the mobile app',
      noDataTitle: 'No Submissions Yet',
      noDataDesc: 'Submissions from your mobile app will appear here',
      records: 'records',
      startDate: 'Start Date',
      endDate: 'End Date',
      search: 'Search point name',
      searchBtn: 'Search',
      idCol: '#',
      pointNameCol: 'Point Name',
      dateCol: 'Date',
      locationCol: 'Location',
      fieldsCol: 'Fields',
      actionsCol: 'Actions',
      fields: 'fields',
      details: 'Submission Details',
      pointName: 'Point Name',
      submittedAt: 'Submitted At',
      coordinates: 'Coordinates',
      openInMaps: 'Open in Maps',
      dynamicFields: 'Dynamic Fields',
      image: 'Image',
      fetchError: 'Failed to load submissions'
    },
    PROFILE: {
      email: 'Email Address',
      USER_TITLE: 'User Information',
      FULL_NAME: 'Full Name',
      USERNAME: 'Username',
      PHONE: 'Phone Number',
      UPDATE_BUTTON: 'Update Data',
      MEMBER_SINCE: 'Member',
      MEMBER: 'Member',
    }
  },
  translation_ar: {
    GLOBAL: {
      cancel_button: 'الغاء',
      save_button: 'حفظ',
      GRID_NO_DATA: 'لا توجد بيانات',
      GRID_NO_RESULT_DATA: 'لا توجد بيانات',
      action_edit: 'تعديل',
      action_view: 'عرض',
      action_delete: "حذف",
      action_restore: 'استعادة',
      action_rating: 'تقييم',
      SEARCH_RESULT_OF_SEARCH: "النتيجة",
      SEARCH_SEARCH_BUTTON: 'بحث',
      SEARCH_CLEAR_BUTTON: "مسح",
      Save: 'حفظ',
      close: 'اغلاق',
      SEARCH_RESULT_OF_selected: "المحددة",
      alertPopup: 'تحديث بيانات المستخدم',
      updateUserInfo: 'تحديث',
      endSessionMessage: 'تم انتهاء الجلسة الخاصة بك سيتم تحويلك لصفحة التسجل خلال',
      endSessionMessageUnits: 'ثانية',
      sessionEnding: 'انتهاء الجلسة',
      sorry: 'عذراً!',
      sorryMessage: "عذرا لم نتمكن من تحويلك الى صفحة تسجيل الدخول، رجاءا قم  بتسجيل الدخول مره اخرى من النظام الرئيسي",
      pageNotFound: 'الصفحة غير موجودة',
      pageNotFoundMessage: "عذرا الصفحة التي تبحث عنها غير موجودة او تم نقلها",
      returnHome: 'العودة للنظام الرئيسي',
      goHome: 'العودة للرئيسية',
      goBack: 'رجوع',
      needHelp: 'تحتاج مساعدة؟ تواصل مع الدعم.',
      online: 'متصل',
      clear: 'مسح',
      language: 'اللغة',
      arabic: 'العربية',
      english: 'الإنجليزية'
    },
    LOGIN: {
      login_title: 'تسجيل دخول',
      company_name: 'نظام Milestone',
      company_title: 'لادارة المجمعات السكنية والعقارات',
      wellcome_message: 'مرحبا بك في نظام Milestone',
      Introductory_message: 'هذا نظام آمن وستحتاج إلى تقديم تفاصيل تسجيل الدخول الخاصة بك للوصول إلى الموقع.',
      user_name: 'اسم المستخدم',
      user_password: 'كلمة المرور',
      checkbox_remember_me: 'تذكرني',
      login: 'تسجيل دخول',
      forget_password: 'هل نسية كلمة المرور؟',
      footer_message: 'مقدم من شركة ركن الحلول المتكاملة لتقنية المعلومات',
      reset_password_title: 'أكتب رقم الهاتف الخاص بك لاستعادة كلمة المرور',
      phone_number: 'رقم الهاتف',
      Submit: 'أرسال',
      recived_sms_code_title: 'أدخل الرمز المرسل اليك برسالة قصيرة',
      not_recivied_message: 'لم يصلك الرمز ؟',
      reSend_message: 'أعادة ارسال',
      new_password_form_title: 'يرجى كتابة كلمة المرور الجديدة الان',
      confirm_user_password: 'تأكيد كلمة المرور',
      save_changes_passwords: 'حفظ التغييرات',
    },
    ERROR: {
      login_username_error: 'اسم المستخدم مطلوب',
      login_userpassword_error: 'يجب ادخال كلمة المرور',
      userName_or_password_error: 'اسم المستخدم او كلمة المرور غير صحيحة'

    },
    SIDEMENU: {
      dashboard: 'لوحة التحكم',
      Requests: 'الطلبات',
      profiel: 'الملف الشخصي',
      logout: 'تسجيل خروج',
      units: 'الوحدات',
      welcome: 'الرئيسية',
      systemTitle: "نظام إدارة الموارد",
      dynamicFields: 'الحقول الديناميكية',
      geoExtractor: 'استعراض النقاط',
      submissions: 'البيانات المرسلة'
    },
    WELCOME: {
      goodMorning: 'صباح الخير',
      goodAfternoon: 'مساء الخير',
      goodEvening: 'مساء الخير',
      totalVehicles: 'إجمالي المركبات',
      activeNow: 'نشط الآن',
      allUnits: 'جميع الوحدات',
      activeUnits: 'الوحدات النشطة',
      currentlyActive: 'نشط حالياً',
      activity: 'النشاط',
      lastHour: 'آخر ساعة',
      uptime: 'وقت التشغيل',
      systemStatus: 'حالة النظام',
      security: 'الأمان',
      secure: 'آمن',
      allSystemsGo: 'جميع الأنظمة تعمل',
      quickActions: 'إجراءات سريعة',
      viewDashboard: 'عرض لوحة التحكم',
      dashboardDesc: 'راقب جميع مركباتك في الوقت الفعلي',
      manageFleet: 'إدارة الأسطول',
      fleetDesc: 'إضافة أو تعديل أو حذف المركبات',
      geoExtractor: 'استعراض النقاط',
      geoExtractorDesc: 'استخراج وتصفح بيانات المناطق الجغرافية من مواردك',
      dynamicFields: 'الحقول الديناميكية',
      dynamicFieldsDesc: 'تكوين حقول مخصصة لنماذج تطبيقك المحمول',
      sessionActive: 'الجلسة نشطة',
      activeStatus: 'نشط',
      blockedStatus: 'محظور',
      daysLeft: 'الأيام المتبقية',
      remaining: 'أيام متبقية',
      accountStatus: 'حالة الحساب',
      accountName: 'اسم الحساب',
      accountStatistics: 'إحصائيات الحساب',
      accountID: 'معرف الحساب'
    },
    LANDING: {
      initializingSession: 'جاري تهيئة الجلسة',
      connectingToWialon: 'جاري الاتصال بـ Wialon...',
      verifyingSession: 'جاري التحقق من الجلسة...',
      loadingData: 'جاري تحميل البيانات...',
      missingSession: "معلمات الجلسة المفقودة",
      ready: 'جاهز!',
      connect: 'اتصال',
      verify: 'تحقق',
      load: 'تحميل',
      authenticationFailed: 'فشل المصادقة',
      pleaseTryLoggingInAgain: 'يرجى المحاولة مرة أخرى من النظام الرئيسي.',
      redirectingToLogin: 'جاري إعادة التوجيه...'
    },
    DYNAMIC_FIELDS: {
      title: 'الحقول الديناميكية',
      subtitle: 'تكوين حقول مخصصة لنماذج تطبيقك المحمول',
      addField: 'إضافة حقل',
      editField: 'تعديل الحقل',
      addNewField: 'إضافة حقل جديد',
      noFieldsTitle: 'لا توجد حقول مخصصة بعد',
      noFieldsDesc: 'أنشئ حقولاً مخصصة لجمع بيانات إضافية من مستخدمي تطبيقك',
      createFirstField: 'أنشئ حقلك الأول',
      orderCol: '#',
      labelCol: 'اسم الحقل',
      typeCol: 'النوع',
      requiredCol: 'مطلوب',
      actionsCol: 'الإجراءات',
      fieldLabel: 'عنوان الحقل',
      labelHelp: 'الاسم المعروض للمستخدمين',
      fieldName: 'اسم الحقل',
      nameHelp: 'معرف داخلي (بدون مسافات)',
      fieldType: 'نوع الحقل',
      options: 'الخيارات (خيار لكل سطر)',
      required: 'حقل مطلوب',
      displayOrder: 'ترتيب العرض',
      orderHelp: 'الأرقام الأصغر تظهر أولاً',
      cancel: 'إلغاء',
      save: 'حفظ',
      delete: 'حذف',
      yes: 'نعم',
      no: 'لا',
      fetchError: 'فشل في تحميل الحقول',
      validationError: 'اسم الحقل والعنوان مطلوبان',
      updateSuccess: 'تم تحديث الحقل بنجاح',
      createSuccess: 'تم إنشاء الحقل بنجاح',
      saveError: 'فشل في حفظ الحقل',
      deleteSuccess: 'تم حذف الحقل بنجاح',
      deleteError: 'فشل في حذف الحقل',
      deleteConfirmTitle: 'حذف الحقل؟',
      deleteConfirmMessage: 'هل أنت متأكد من حذف هذا الحقل؟ لا يمكن التراجع عن هذا الإجراء.',
      restoreSuccess: 'تم استعادة الحقل بنجاح',
      restoreError: 'فشل في استعادة الحقل',
      restoreConfirmTitle: 'استعادة الحقل؟',
      restoreConfirmMessage: 'هل أنت متأكد من استعادة هذا الحقل؟ سيصبح نشطاً مرة أخرى في تطبيق الهاتف المحمول.',
      pointTitlePreview: 'معاينة عنوان النقطة',
      searchPlaceholder: 'البحث عن اسم الحقل أو العنوان...',
      filterType: 'نوع الحقل',
      allTypes: 'جميع الأنواع',
      filterMandatory: 'حالة الإلزام',
      allStatus: 'الكل',
      statusRequired: 'إلزامي',
      statusOptional: 'اختياري'
    },
    GEO_EXTRACTOR: {
      title: 'استعراض النقاط',
      subtitle: 'استخراج وتصفح بيانات المناطق الجغرافية من مواردك',
      selectResource: 'اختر المورد',
      search: 'بحث...',
      refresh: 'تحديث',
      export: 'تصدير اكسل',
      print: 'طباعة',
      viewTable: 'عرض الجدول',
      viewMap: 'الخريطة',
      fullscreen: 'ملء الشاشة',
      exitFullscreen: 'خروج من ملء الشاشة',
      openInGoogleMaps: 'فتح في خرائط جوجل',
      totalPoints: 'إجمالي النقاط',
      matchingResults: 'مطابقة',
      extraFields: 'حقول إضافية',
      loadingResources: 'جاري تحميل الموارد...',
      loadingZones: 'جاري معالجة المناطق الجغرافية...',
      loadError: 'فشل في تحميل الموارد',
      processError: 'فشل في معالجة بيانات المناطق الجغرافية',
      noData: 'لا توجد نقاط WenkTag',
      noDataDesc: 'هذا المورد لا يحتوي على نقاط جغرافية بتنسيق WenkTag. حاول اختيار مورد آخر.',
      hideEmpty: 'إخفاء الموارد الفارغة',
      searchSalesman: 'بحث اسم صاحب العمل...',
      selectColumns: 'اختر الحقول...',
      searchDynamicFields: 'بحث في الحقول مخصصة...',
      advancedSearch: 'البحث المتقدم',
      resetFilters: 'مسح الفلاتر'
    },
    SUBMISSIONS: {
      title: 'البيانات المرسلة',
      subtitle: 'عرض وإدارة البيانات المرسلة من التطبيق',
      noDataTitle: 'لا توجد بيانات مرسلة بعد',
      noDataDesc: 'ستظهر البيانات المرسلة من تطبيقك هنا',
      records: 'سجل',
      startDate: 'من تاريخ',
      endDate: 'إلى تاريخ',
      search: 'البحث عن اسم النقطة',
      searchBtn: 'بحث',
      idCol: '#',
      pointNameCol: 'اسم النقطة',
      dateCol: 'التاريخ',
      locationCol: 'الموقع',
      fieldsCol: 'الحقول',
      actionsCol: 'الإجراءات',
      fields: 'حقول',
      details: 'تفاصيل البيانات المرسلة',
      pointName: 'اسم النقطة',
      submittedAt: 'تاريخ الإرسال',
      coordinates: 'الإحداثيات',
      openInMaps: 'فتح في الخرائط',
      dynamicFields: 'الحقول الديناميكية',
      image: 'الصورة',
      fetchError: 'فشل في تحميل البيانات المرسلة'
    },
    DASHBOARD: {
      request_wait: 'الطلبات  في الانتظار',
      request_canceled: 'الطلبات الملغاة',
      request_completed: 'الطلبات المكتملة',
      request_sum: 'جميع الطلبات',
      unit_counts: 'عدد الوحدات',
      title: 'لوحة التحكم',
      request_new: 'الطلبات الجديدة',
      show_status_title: 'مخطط نسب الحالات للطلبات',
      show_RatedScore_title: 'مخطط التقييم للطلبات'
    },
    ADVANCESEARCH: {
      title: 'البحث عن عملاء',
      customer_name: 'أسم العميل',
      customer_phone_number: 'رقم الهاتف',
      Name_ofCumpany: "تاريخ التسجيل",
      fromDate: 'من ',
      toDate: 'الى',
      no_cutomerTypeData: 'لا توجد بيانات',
      SelectCustomerWorkType: 'نوع العميل',
      salesEmployee: 'موظف المبيعات',
      selectedReason: 'الغرض',
      no_resones: 'لا توجد بيانات',
      advancesearch: 'البحث المتقدم',
      applaySearch: 'تطبيق البحث',
      sideOfWork: 'جهة العمل',
      no_workside: 'لا توجد بيانات',
      companyname: 'اسم الشركة',


    },
    REQUESTS: {
      title: 'الطلبات',
      ID: '#',
      accountName: 'اسم الحساب',
      accountUserName: 'اسم المستخدم',
      dateforRequest: 'رقم وتاريخ الطلب',
      requestNumber: 'رقم الطلب',
      requestType: 'نوع الطلب',
      deviceNumber: 'رقم الجهاز',
      dateAndFavoriteTIme: 'التاريخ والوقت المفضل',
      status: 'الحالة',
      actions: 'الوظائف',
      archived_request: "مؤرشفة",
      approved_request: "تمة الموافقة",
      rejected_request: "رفضت",
      closed_request: "مغلقة",
      inprogress_request: "قيد المعالجة",
      new_request: 'جديد',
      requestDate: 'من تاريخ الطلب',
      endrequestDate: 'الى تاريخ طلب',
      unitName: 'اسم الوحدة',
      addTitle: 'أضافة طلب',
      updateTitle: 'تعديل بيانات الطلب',
      add_phone: 'رقم الهاتف',
      add_location: 'مكان الطلب',
      add_request_type: 'نوع الطلب',
      add_units: 'الوحدات',
      add_prefered_date: 'التاريخ المفضل',
      add_prefered_time: 'الوقت المفضل',
      add_notes: 'الملاحضات',
      add_customer_name: 'اسم الزبون',
      add_username: 'اسم المستخدم',
      add_request_date: 'تاريخ الطلب',
      add_status: 'الحالة',
      add_inprogress_dateTime: 'وقت وتاريخ بدء العمل',
      add_closing_dateTIme: 'وقت وتاريخ الاغلاق',
      add_unit_reasone: 'السبب',
      add_unit_name: 'اسم الوحدة',
      add_unit_id: '#',
      no_menu_itme: 'لا توجد عناصر تحكم',
      viewRequest: 'عرض تفاصيل الطلب',
      units_list: 'قائمة الوحدات',
      ratedRequest: 'نوع التقييم',
      rating: 'التقييم',
      addRating: 'اضافة تقييم',
      add_ratingsNot: 'ملاحظات',
      add_rating_suggestions: 'اي اقتراح',
      maessage_after_rating_1: 'شكرا لوقتك. نحن ناسف لتجربتك الغير جيدة. سوف يتم الاتصال بحضرتك لبحث سبب المشكلة والعمل على حلها في المستقبل',
      maessage_after_rating_2: 'شكرا لوقتك. نحن ناسف لتجربتك الغير جيدة. سوف يتم الاتصال بحضرتك لبحث سبب المشكلة والعمل على حلها في المستقبل',
      maessage_after_rating_3: 'شكرا لوقتك. على ما يبدوا ان تجربتك لم تكن ممتازة. سوف يتم مراجعة تقييمك والعمل على اصلاح الخلل',
      maessage_after_rating_4: 'شكرا لوقتك. نحن نعمل على تقديم أفضل الخدمات. نأمل بان نقدم لك خدمة أفضل في المستقبل',
      maessage_after_rating_5: 'شكرا لوقتك. نحن سعداء بخدمتك',
      unitName_details: 'تفاصيل الوحدات',
      reasonTitle: "اضفافة ملاحظة",
      notesReason: 'ملاحظة',
      noteReason: 'ملاحظة',
      add_unit_notes: 'السبب',
      commentsCount: 'عدد التعليقات',
      viewRequestComments: 'التعليقات',
      commentText: 'التعليق',
      commentDate: 'تاريخ التعليق',
      commenter: 'المعلق',
      noData: 'لا توجد بيانات',
      youMustSelectTask: 'يجب ان تختار المهمة ',
      comments: 'التعليقات',
      Images: 'الصور'
    },
    NETWORKMESSAGE: {
      addCustomerMessageSuccess: 'تم اضافة المعلومات بنجاح',
      updateCustomerMessageSuccess: 'تم تحديث المعلومات بنجاح',
      addCustomerMessageError: 'خطء غير معروف',
      deleteErrorr: 'خطء غير معروف',
      deleteSuccess: 'تم الحذف بنجاح'
    },
    TOOLTIP: {
      EXPORT: 'تصدير',
      IMPORT: 'استيراد',
      CREATE: 'انشاء',
      MAP: 'خريطة',
      TELEGRAM: 'تليكرام',
    },
    PROFILE: {
      email: 'البريد الالكتروني',
      USER_TITLE: 'معلومات المستخدم',
      FULL_NAME: "أسم المستخدم كامل",
      USERNAME: 'اسم المستخدم',
      PHONE: "رقم الهاتف",
      UPDATE_BUTTON: "تحديث البيانات",
      MEMBER_SINCE: 'عضو منذ',
      MEMBER: 'عضو',
    },
    UNITS: {
      title: 'الوحدات',
    }


  },

};
export const TranslateSlice = createSlice({
  name: "translateData",
  initialState: initialState,
  reducers: {
    setTranslateEnglish: (state, action) => {
      state.translation_en = action.payload
    },
    setTranslateArabic: (state, action) => {
      state.translation_ar = action.payload
    },
  },
});

export const {
  setTranslateEnglish,
  setTranslateArabic,
} = TranslateSlice.actions;

// export const sideMenuMode = state => state.settingsData.sideMenuMode;

export default TranslateSlice.reducer;
